<template>
  <div ref="simpleWorkflow">
    <div>
      <Workflow
        v-for="(workflow, key) in workflows"
        :key="key"
        :workflowKey="key"
        :workflowItem="parse(workflow)"
        @removed="removed"
        @updated="updated"
      />
    </div>
    <div class="mt-3">
      <b-button variant="primary" size="sm" @click="add" :disabled="inProcess">
        <icon name="plus" />
        <span>Add A New Rule</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { cloneDeep, merge } from 'lodash'
// components
import Workflow from './Workflow'
// services
import db from '@/services/db'

export default {
  components: {
    Workflow,
  },
  data() {
    return {
      workflows: {},
      defaultRule: {},
      inProcess: false,
    }
  },
  computed: {
    ...mapState(['simpleWorkflows']),
  },
  methods: {
    parse(workflow) {
      try {
        return JSON.parse(workflow)
      } catch (err) {
        console.error(err)

        return cloneDeep(this.defaultRule)
      }
    },
    add() {
      this.inProcess = true

      db.simpleWorkflow.add(key => {
        this.workflows = merge(this.workflows, {
          [key]: JSON.stringify(this.defaultRule),
        })

        this.inProcess = false
      })
    },
    updated(key) {
      const newWorkflows = cloneDeep(this.workflows)

      newWorkflows[key] = cloneDeep(this.simpleWorkflows[key])

      this.workflows = newWorkflows
    },
    removed(key) {
      const newWorkflows = cloneDeep(this.workflows)

      delete newWorkflows[key]

      this.workflows = newWorkflows
    },
  },
  created() {
    this.workflows = cloneDeep(this.simpleWorkflows)
  },
}
</script>

<style lang="scss">
@import '~$scss/globals';

.simpleWorkflow {
  padding: 10px;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
  &__item {
    min-height: 45px;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
    select {
      width: auto;
      display: inline !important;
      margin: 5px;
    }
  }
  &__itemRemove {
    float: right;
    position: absolute;
    right: 10px;
    margin-top: 5px;
    top: 5px;
  }
  &__action {
    position: relative;
    border: 1px solid #ddd;
    &:first-child {
      margin-top: 10px;
    }
    margin-bottom: 10px;
    padding: {
      left: 10px;
      right: 20px;
      top: 5px;
      bottom: 5px;
    }
  }
  &__actionRemove {
    position: absolute;
    right: 5px;
    top: 0px;
  }
  &._addExpression {
    position: relative;
    padding: {
      left: 0;
      right: 0;
    }
    span {
      margin-right: 5px;
    }
    textarea {
      display: inline;
      position: relative;
      top: 12px;
      width: 240px;
    }
    a {
      margin-left: 7px;
    }
  }
  select {
    border: {
      left: 0;
      right: 0;
      top: 0;
      radius: 0;
    }
    box-shadow: none;
    font: {
      size: 14px;
      weight: bold;
    }
    color: #525f7f;
    padding: {
      top: 0;
      bottom: 0;
    }
  }
}
</style>
